import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./Header.module.css";
import logo from "../../assets/Home/Logo.svg";
import serachIcon from "../../assets/Home/iconSearch.svg";
import alertIcon from "../../assets/Home/alert-icon.svg";
import closeIcon from "../../assets/Profile/XIcon.svg";
import { Alert } from "../../components/Alert/";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../context/Auth";
import { NavLink, useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { NemuContext } from "../../utils/NemuContext";
import logountIcon from "../../assets/Profile/logout_icon.svg";

function Header({ name }) {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [developments, setDevelopments] = useState([]);
  const [enterprises, setEnterprises] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const { selectedProp, setSelectedProp } = React.useContext(NemuContext);
  const navigate = useNavigate();

  const getAbbreviation = (username) => {
    if (!username) return "";
    const words = username.split(" ");
    const initials = words.map((word) => word[0]?.toUpperCase());
    return initials.join("");
  };

  const fetchSearchDevelopment = async () => {
    try {
      const response = await axios.get(`${api}/development/search`, {
        params: { searchTerm: value },
        headers: {
          "Content-Type": "application/json",
        },
      });
      setDevelopments(response.data.developments || []);
      setEnterprises(response.data.enterprises || []);
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogout = () => {
        logout();
        navigate("/");
  };

  useEffect(() => {
    if (value) {
      fetchSearchDevelopment();
    }
  }, [value]);

  useEffect(() => {
    if (user) {
      setUserProfile(
        user.profile_picture ? api + "/" + user.profile_picture : null
      );
      setLoading(false);
    }
  }, [user]);

  return (
    <header className="sticky top-0 z-50 flex justify-between items-center bg-gradient-to-b from-nemu-platino from-90% to-nemu-platino/0 h-[100px] w-[100vw] py-[16px] px-[24px]">
      <img src={logo} alt="logo" />
      <div
        className={`${styles["search-container"]} ${
          isFocused ? "ring-2 ring-blue-500 border-blue-500" : ""
        } transition-colors duration-200`}
      >
        <img src={serachIcon} alt="lupa" />
        <input
          type="text"
          onChange={(e) => {
            setValue(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => {
            setIsOpen(true);
            setIsFocused(true);
          }}
          onBlur={() => {
            setTimeout(() => setIsOpen(false), 150);
            setIsFocused(false);
          }}
          placeholder={user?.role === 'admin' ? "Buscar proyecto o Desarrolladora" : "Buscar proyecto"}
        />
        {isOpen && (
          <div
            className="fixed w-[30%] mt-[4.5%] bg-white rounded-lg shadow-lg border top-0 border-gray-200 z-10 max-h-[70vh] overflow-y-auto"
            onMouseDown={(e) => e.preventDefault()}
          >
            {(() => {
              // Empresas: vienen directo del backend (incluye las que tienen
              // 0 desarrollos y hacen match por nombre).
              const hasResults = (user?.role === 'admin' && enterprises.length > 0) || developments.length > 0;

              if (!hasResults && value.trim() !== "") {
                return (
                  <div className="p-3 text-gray-500 text-center text-sm">
                    No se encontraron resultados
                  </div>
                );
              }

              return (
                <>
                  {/* Sección Empresas — solo admin */}
                  {user?.role === 'admin' && enterprises.length > 0 && (
                    <>
                      <p className="px-3 pt-3 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wider">
                        Empresas
                      </p>
                      {enterprises.map((u) => (
                        <div
                          key={u.id}
                          onClick={() => {
                            navigate('/profile', { state: { viewUserId: u.id } });
                            setIsOpen(false);
                          }}
                          className="flex items-center gap-2.5 mx-2 mb-1 px-2 py-2 rounded-lg hover:bg-[#EAEAEA] cursor-pointer"
                        >
                          <Building2 size={15} className="text-gray-400 shrink-0" />
                          <div>
                            <p className="text-gray-800 font-medium text-[14px]">{u.enterprise.name}</p>
                            <p className="text-gray-400 text-[12px]">{u.enterprise.giro || "Empresa"}</p>
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                  {/* Sección Proyectos */}
                  {developments.length > 0 && (
                    <>
                      <p className="px-3 pt-3 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wider">
                        Proyectos
                      </p>
                      {developments.map((project, index) => (
                        <NavLink
                          to='/myprojects'
                          onClick={() => {
                            setSelectedProp(project.id);
                            setIsOpen(false);
                          }}
                          key={index}
                          className="block mx-2 mb-1 last:mb-2"
                        >
                          <div className="hover:bg-[#EAEAEA] px-2 py-2 rounded-lg">
                            <div className="text-gray-800 font-medium text-[14px]">{project.name}</div>
                            <div className="text-gray-500 text-[12px]">
                              {project.user.enterprise.name}
                            </div>
                          </div>
                        </NavLink>
                      ))}
                    </>
                  )}
                </>
              );
            })()}
          </div>
        )}
      </div>
      <div className={styles["container-user"]}>
        <span className={styles.user}>
          {loading ? "Cargando" : user.username}
        </span>
        <div className={styles["picture-container"]}>
          {userProfile ? (
            <img
              src={userProfile}
              alt="Profile"
              className="w-full h-full object-cover rounded-full"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded-full">
              <span className="text-gray-600 text-sm font-medium">
                {loading ? "" : getAbbreviation(user.username)}
              </span>
            </div>
          )}
        </div>
        <div onClick={() => setShowLogout(true)} className="p-2 bg-nemu-platino rounded-lg cursor-pointer transition-all duration-300 hover:invert">
          <img src={logountIcon} className="w-4 h-4"/>
        </div>
        {showLogout && <Alert>
          <div className="flex items-center justify-between gap-3">
            <img src={alertIcon} alt="alert" />
            <h5 className="text-[24px] flex-1">Cerrar sesión</h5>
            <img src={closeIcon} alt="close icon" className="w-6 h-6 rounded-full transition-all duration-300 cursor-pointer hover:rotate-90" onClick={() => setShowLogout(null)}/>           
          </div>
          <p className="text-[24px]">¿Estás seguro de cerrar tu sesión?</p>
          <div className="flex justify-end w-full gap-2">
            <button onClick={() => setShowLogout(false)} className="border border-nemu-black px-4 py-2 rounded-md text-[16px] text-black transition-all duration-200 hover:bg-[#E7E7E7]">Cancelar</button>
            <button onClick={() => handleLogout()} className="bg-[#E72626] px-4 py-2 rounded-md text-[16px] text-white transition-all duration-200 hover:bg-[#D71212]">Cerrar sesión</button>
          </div>
        </Alert>}
      </div>
    </header>
  );
}

export { Header };
